import "../../../css/voucher.css";
import {
  Paper,
  Grid,
  MenuItem,
  FormControl,
  FormGroup,
  FormLabel,
  FormControlLabel,
  Checkbox,
  Button
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import classNames from "classnames";
import DatePicker from "react-datetime";

import { toLocalTime, toUTC } from "../../formatUTC";
import DescriptionComponent from "../../descriptionComponent";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import InputFormat from "../../../partials/inputForm";
import LabelForm from "../../../partials/labelForm";

const styles = theme => ({
  editFormContainer: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    padding: theme.spacing(3),
    borderBottom: "1px solid rgba(224, 224, 224, 1)"
  },
  wrapButton: {
    display: "flex",
    justifyContent: "flex-end"
  },
  root: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(3),
    width: "100%",
    boxSizing: "border-box"
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "8px"
  },
  listItem: {
    // width : '100%',
    height: "100%",
    boxShadow:
      "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);",
    position: "relative"
  },
  buttonIcon: {
    width: 64,
    height: 64,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)"
  },
  icon: {
    cursor: "pointer",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    fontSize: 40
  },
  buttonHover: {
    width: 36,
    height: 36,
    margin: "0px 5px"
  },
  iconHover: {
    cursor: "pointer",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    fontSize: 24
  },
  inputImage: {
    display: "none"
  },
  imageItem: {
    height: "250px",
    cursor: "pointer",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  },
  title: {
    padding: 0,
    fontSize: "1rem",
    fontWeight: "500",
    lineHeight: "normal",
    height: "3rem",
    color: "#000000",
    fontWeight: 900
  },
  textField: {
    marginRight: theme.spacing(1),
    width: "100%"
  },
  label: {
    fontWeight: 410,
    color: "#000000"
  },
  formLabel: {
    marginBottom: theme.spacing(1),
    textTransform: "capitalize",
    fontSize: "0.875rem"
  },
  button: {
    float: "right"
  },
  image: {
    height: "25vw",
    width: "45vw",
    boxShadow:
      "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);",
    backgroundSize: "cover",
    backgroundPosition: "center",
    cursor: "pointer"
    // marginTop: `${theme.spacing(3)}px`,
  },
  marginTop: {
    marginTop: theme.spacing(3)
  },
  customFormLabel: {
    display: "block",
    color: "rgba(0, 0, 0, 0.85)",
    fontWeight: "500"
  },
  inputType: {
    height: "unset"
  }
});

class CampaignCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      campaign: {
        ...this.props.data
      }
    };
  }
  changeAlias = alias => {
    var str = alias;
    str = str.toLowerCase();
    str = str.trim();
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/đ/g, "d")
      .replace(/Đ/g, "D");
  };
  getCode = code => {
    var arr = code.split("-");
    return arr[arr.length - 1];
  };
  handleChange = e => {
    let value = e.target.value;
    let name = e.target.name;
    if (e.target.type === "checkbox") {
      value = e.target.checked ? 1 : 0;
      // value = e.target.checked;
    }
    let campaign = this.state.campaign;
    campaign[name] = value;
    this.setState({ campaign });
  };

  handleChangeContactInfo = (type, field) => {
    let campaign = this.state.campaign;
    let indexField = campaign.contactInfo.findIndex(
      element => element.type == type
    ); // Tìm index
    campaign.contactInfo[indexField][field] = !campaign.contactInfo[indexField][
      field
    ];
    this.setState({ campaign });
  };
  handleSubComponentChange = (name, value) => {
    let campaign = this.state.campaign;
    campaign[name] = value;
    this.setState({ campaign });
  };
  handleChangeDate = (name, date) => {
    let campaign = this.state.campaign;
    let milisecondInLocal =
      date && date._isAMomentObject ? date.valueOf() : moment().valueOf();
    campaign[name] = milisecondInLocal;
    this.setState({ campaign });
  };
  handleSubmitUpdate = async () => {
    let { campaign } = this.state;
    let { t, voucherList } = this.props;
    let voucherSelect = voucherList.find(
      voucher => voucher.code == campaign.code
    ); // Tìm voucher được chọn
    let listImage = [];
    if (voucherSelect) {
      listImage = JSON.parse(voucherSelect.imageGallery);
    }
    campaign.banner = listImage;
    campaign.searchingText = this.changeAlias(campaign.title);
    this.loading.startLoading();
    let check = await this.props.update(campaign);
    this.loading.stopLoading();
    this.props.finishUpdate(check);
  };
  handleCheck = () => {
    const { campaign } = this.state;
    const { t } = this.props;
    if (!campaign.type)
      this.mSnackbar.handleClick(
        t("campaign_add_campaign_please_add_type"),
        "warning"
      );
    else if (!campaign.code)
      this.mSnackbar.handleClick(
        t("campaign_add_campaign_please_add_voucher"),
        "warning"
      );
    else if (!campaign.startDate)
      this.mSnackbar.handleClick(
        t("campaign_add_campaign_please_add_start_date"),
        "warning"
      );
    else if (!campaign.endDate)
      this.mSnackbar.handleClick(
        t("campaign_add_campaign_please_add_end_date"),
        "warning"
      );
    else {
      this.handleSubmitUpdate();
    }
  };

  renderImage = () => {
    const { classes, t, voucherList } = this.props;
    const { campaign } = this.state;
    if (campaign.type == "voucher" && campaign.code) {
      // đã chọn voucher
      let voucherSelect = voucherList.find(
        voucher => voucher.code == campaign.code
      ); // Tìm voucher được chọn
      let listImage = [];
      if (voucherSelect) {
        listImage = JSON.parse(voucherSelect.imageGallery);
      }
      return (
        <React.Fragment>
          <Grid item xs={12} sm={12} md={12} style={{ paddingBottom: "0" }}>
            <LabelForm label={t("campaign_add_campaign_image")} />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Grid container spacing={3}>
              {listImage.map((img, index) => {
                return (
                  <Grid item sx={6} sm={4} md={4} lg={3}>
                    <div
                      className={classes.listItem + " list-item-image-album"}
                    >
                      <div className="bg-hover-image-album">
                        {/* <div className="bg-hover-image-album-icon">
                          <IconButton
                            className={classes.buttonHover + " f-left"}
                            aria-label="Zoom"
                          >
                            <Icon
                              className={
                                classes.iconHover + " fa fa-arrows-alt"
                              }
                              color="inherit"
                            />
                          </IconButton>
                          <IconButton
                            className={classes.buttonHover + " f-right"}
                            aria-label="Delete"
                          >
                            <Icon
                              className={classes.iconHover + " fa fa-trash"}
                              color="inherit"
                            />
                          </IconButton>
                        </div> */}
                      </div>
                      <div
                        className={classes.imageItem}
                        style={{ backgroundImage: `url(${img})` }}
                      ></div>
                    </div>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </React.Fragment>
      );
    }
  };

  render() {
    const { classes, t, voucherList, i18n } = this.props;
    const { campaign } = this.state;

    return (
      <Paper square={true} className={classes.editFormContainer}>
        <Loading onRef={id => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={snackbar => (this.mSnackbar = snackbar)}
        />
        <Grid container spacing={3}>
          <Grid
            item
            xs={4}
            sm={4}
            style={{ alignItems: "flex-end", display: "flex" }}
          >
            <InputFormat
              label={t("campaign_add_campaign_title")}
              margin="normal"
              name="title"
              value={campaign.title}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid
            item
            xs={4}
            sm={4}
            style={{ alignItems: "flex-end", display: "flex" }}
          >
            <InputFormat
              select
              label={t("campaign_add_campaign_type")}
              name="type"
              margin="normal"
              required
              fullWidth
              value={campaign.type}
              onChange={this.handleChange}
            >
              <MenuItem value="voucher">
                {t("campaign_add_campaign_voucher")}
              </MenuItem>
              {/* <MenuItem value='game'>{t('campaign_add_campaign_game')}</MenuItem>  */}
            </InputFormat>
          </Grid>
          <Grid item xs={4} sm={4}>
            {campaign.type == "voucher" && (
              <InputFormat
                select
                label={t("campaign_add_campaign_voucher")}
                name="code"
                margin="normal"
                required
                fullWidth
                value={campaign.code}
                onChange={this.handleChange}
              >
                {voucherList.map((item, index) => {
                  return (
                    <MenuItem key={`voucher-${index}`} value={item.code}>
                      {item.title}
                    </MenuItem>
                  );
                })}
              </InputFormat>
            )}
          </Grid>
          <Grid item xs={6} sm={6}>
            <DatePicker
              renderInput={props => (
                <InputFormat
                  required
                  label={t("campaign_add_campaign_start_date")}
                  margin="normal"
                  onChange={this.handleChange}
                  InputProps={{
                    ...props
                  }}
                />
              )}
              className={classes.textField}
              timeFormat="hh:mm A"
              dateFormat="DD/MM/YYYY"
              onChange={date => this.handleChangeDate("startDate", date)}
              value={campaign.startDate}
              defaultValue={moment().valueOf()}
              locale={i18n.language === "vn" ? "vi" : "en"}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <DatePicker
              renderInput={props => (
                <InputFormat
                  required
                  label={t("campaign_add_campaign_end_date")}
                  margin="normal"
                  onChange={this.handleChange}
                  InputProps={{
                    ...props
                  }}
                />
              )}
              className={classes.textField}
              timeFormat="hh:mm A"
              dateFormat="DD/MM/YYYY"
              onChange={date => this.handleChangeDate("endDate", date)}
              value={campaign.endDate}
              defaultValue={moment().valueOf()}
              locale={i18n.language === "vn" ? "vi" : "en"}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={campaign.enable ? true : false}
                  // checked={campaign.enable}
                  name="enable"
                  onChange={this.handleChange}
                />
              }
              className={classes.label}
              label={t("campaign_add_campaign_enable")}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={campaign.isCommingSoon ? true : false}
                  // checked={campaign.isCommingSoon}
                  name="isCommingSoon"
                  onChange={this.handleChange}
                />
              }
              className={classes.label}
              label={t("campaign_add_campaign_isCommingSoon")}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <DescriptionComponent
              onRef={id => (this.DescriptionComponent = id)}
              title={t("campaign_add_campaign_content")}
              handleSubComponentChange={this.handleSubComponentChange}
              description={campaign.content}
              nameInput="content"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <FormLabel component="legend" className={classes.title}>
              {t("campaign_add_campaign_contact_info")}
            </FormLabel>
            <Grid container spacing={3}>
              {campaign.contactInfo.map((item, index) => {
                return (
                  <Grid key={`contact-${index}`} item xs={4} sm={3} md={2}>
                    <FormControl
                      component="fieldset"
                      className={classes.formControl}
                    >
                      <FormLabel
                        component="legend"
                        className={classes.formLabel}
                      >
                        {t(`campaign_add_campaign_${item.type}`)}
                      </FormLabel>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={item.isShow}
                              name={`${item.type}-show`}
                              onChange={() =>
                                this.handleChangeContactInfo(
                                  item.type,
                                  "isShow"
                                )
                              }
                            />
                          }
                          className={classes.label}
                          label={t("campaign_add_campaign_isShow")}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={item.isRequired}
                              name={`${item.type}-require`}
                              onChange={() =>
                                this.handleChangeContactInfo(
                                  item.type,
                                  "isRequired"
                                )
                              }
                            />
                          }
                          className={classes.label}
                          label={t("campaign_add_campaign_isRequired")}
                        />
                      </FormGroup>
                    </FormControl>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
          {this.renderImage()}
          <Grid item xs={12} sm={12} md={12} className={classes.wrapButton}>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleCheck}
            >
              {t("membercard_add_save")}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

CampaignCard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

const mapState = state => ({
  voucherList: state.voucher.voucherList,
  serviceCode: state.user.user.roleId.serviceCode
});

const mapDispatch = dispatch => ({
  update: dispatch.campaigns.update
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(CampaignCard)
  )
);
